var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrophoneIcon = function SvgMicrophoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M.5 0h24v24H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.25 20.25v1.5h2.25v1.5h-6v-1.5h2.25v-1.5A8.25 8.25 0 0 1 4.25 12h1.5a6.75 6.75 0 0 0 13.5 0h1.5a8.25 8.25 0 0 1-7.5 8.25m-6-8.25V6a5.25 5.25 0 0 1 10.5 0v6a5.25 5.25 0 0 1-10.5 0m1.5 0a3.75 3.75 0 1 0 7.5 0V6a3.75 3.75 0 0 0-7.5 0z",
    clipRule: "evenodd"
  })));
};
export default SvgMicrophoneIcon;